import { Box, Button, Card, Grid, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import Chart from 'react-apexcharts';
import Dashlet from '../components/common/Dashlet';
import PageContainer from '../components/PageContainer';
import { getDashboardStatsForLoggedInInternalUser } from '../redux/api/cases';

const colors = [
    '#007bff',
    '#6610f2',
    '#dc3545',
    '#fd7e14',
    '#ffc107',
    '#28a745',
    '#20c997',
    '#17a2b8',
    '#e83e8c',
    '#6c757d',
    '#343a40',
    '#007bff',
    '#6c757d',
    '#28a745',
    '#17a2b8',
    '#ffc107',
    '#dc3545',
    '#f8f9fa',
    '#343a40',
];

const ImpactChart = ({ analytics }) => {
    const arr = Object.keys(analytics)?.filter((k) => k !== 'ALL');
    const series = [
        {
            name: '',
            data: [...arr?.map((ky) => analytics[ky] || 0)],
        },
    ];
    const options = {
        chart: {
            height: 350,
            type: 'bar',
            events: {
                click: function (chart, w, e) {},
            },
        },
        colors: colors,
        plotOptions: {
            bar: {
                columnWidth: '50%',
                distributed: true,
            },
        },
        dataLabels: {
            enabled: false,
            textAnchor: 'middle',
            distributed: true,
        },
        legend: {
            show: true,
            horizontalAlign: 'center',
            position: 'bottom',
            onItemClick: {
                toggleDataSeries: true,
            },
            onItemHover: {
                highlightDataSeries: true,
            },
        },
        xaxis: {
            categories: [...arr],
            labels: {
                show: false,
                style: {
                    colors: colors,
                    fontSize: '12px',
                },
            },
        },
    };

    return <Chart series={series} options={options} type="bar" width={'100%'} height={350} />;
};

const Dashboard = () => {
    const [processing, setProcessing] = useState(false);
    const [analytics, setAnalytics] = useState(null);

    const init = async () => {
        try {
            setProcessing(true);
            const { resultObject } = await getDashboardStatsForLoggedInInternalUser();
            const refinedData = await new Promise((resolve) => {
                let obj = {};
                resultObject.forEach((dt, index) => {
                    let val = {};
                    dt.statValues?.map((st) => (val[st.instName] = st?.caseCount));
                    val['ALL'] = Object.values(val).reduce((prev, nx) => prev + nx, 0);
                    obj[dt.statName] = val;

                    if (resultObject?.length === Object.keys(obj).length) resolve(obj);
                });
            });
            setAnalytics(refinedData);
        } catch (err) {
            console.log(err);
        } finally {
            setProcessing(false);
        }
    };

    useEffect(() => {
        init();
    }, []);

    return (
        <PageContainer processing={processing} pageTitle="Dashboard">
            <div className="pl-1 pr-1">
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6} md={4}>
                        <Dashlet title="My Cases" data={analytics?.myCases?.['ALL'] || 0} subtitle={`${analytics?.myCases[0]?.caseCount || 0} Cases this Month`} />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <Dashlet title="My Open Cases" data={analytics?.MyOpenCasesStats?.['ALL'] || 0} subtitle={`${analytics?.AllMonthlyBreachedCases || 0} Cases this Month`} />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <Dashlet title="Closed Cases" data={analytics?.myClosedCasesStats?.['ALL'] || 0} subtitle={`${analytics?.AllMonthlyClosedCases || 0} Cases this Month`} />
                    </Grid>
                </Grid>

                {analytics && (
                    <Grid container className="mt-2" spacing={3}>
                        {
                            <Grid item xs={12}>
                                <Card className="P-5">
                                    <h5 className="ml-1 mb-05 mt-1">Breached Cases</h5>
                                    <ImpactChart analytics={analytics.BreachedCases} />
                                </Card>
                            </Grid>
                        }
                        {
                            <Grid item xs={12}>
                                <Card className="P-5">
                                    <h5 className="ml-1 mb-05 mt-1">Open Cases</h5>
                                    <ImpactChart analytics={analytics.OpenCases} />
                                </Card>
                            </Grid>
                        }
                        {
                            <Grid item xs={12}>
                                <Card className="P-5">
                                    <h5 className="ml-1 mb-05 mt-1">Closed Cases</h5>
                                    <ImpactChart analytics={analytics.ClosedCases} />
                                </Card>
                            </Grid>
                        }
                    </Grid>
                )}
            </div>
        </PageContainer>
    );
};

export default Dashboard;
